import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ProvideAuth} from "./lib/auth/useAuth";
import { setChonkyDefaults } from 'chonky';
import { ChonkyIconFA } from 'chonky-icon-fontawesome';
import { Provider } from 'react-redux'
import store from './store'


ReactDOM.render(
  <ProvideAuth>
    <Provider store={store}>
      <App/>
    </Provider>
  </ProvideAuth>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

setChonkyDefaults({ iconComponent: ChonkyIconFA });
